var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5922 5.44469V1.29652C16.5922 0.644664 16.0588 0.111328 15.407 0.111328H1.1847C0.532848 0.111328 -0.000488281 0.644664 -0.000488281 1.29652V13.1484C-0.000488281 13.8003 0.532848 14.3336 1.1847 14.3336H15.407C16.0588 14.3336 16.5922 13.8003 16.5922 13.1484V9.00026L21.333 13.741V0.703924L16.5922 5.44469Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOn);
export default __webpack_public_path__ + "static/media/CameraOn.addfe12b4e13907ecb7c4cc3ac6c876b.svg";
export { ForwardRef as ReactComponent };